module.exports = __webpack_public_path__ + "i18n/pl.a14519bbcee570a5989fc12c145285b7.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/pl.json
// module id = 853
// module chunks = 60